import { REDUCER_NAME } from "./config";

export const selectors = {
  selectIsDocsDeduping: (docType) => (state) =>
    Boolean(state[REDUCER_NAME]?.dedupingDocs?.includes(docType)),
};
